import { render, staticRenderFns } from "./CandidatesListFilters.vue?vue&type=template&id=4927f30e&lang=pug"
import script from "./CandidatesListFilters.vue?vue&type=script&lang=js"
export * from "./CandidatesListFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports